import React from "react";
import BlockTitle from "../../Shared/BlockTitle/BlockTitle";
import Categories from "./Categories/Categories";
import Location from "./Location/Location";
import Search from "./Search/Search";

const Filter = () => {
  return (
    <div className="w-1/4">
      <BlockTitle text="Filter" />
      <Search />
      <Location />
      <Categories />
    </div>
  );
};

export default Filter;
